// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"bc3ed34d34f7b74788c9","655":"97a57ac73f4d207a2f4f"}[chunkId] + ".js";
};